export default {
      id: "camera-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite.svg#camera",
      toString: function () {
        return this.url;
      }
    }